import commonEnvironment from 'config/de-CH/common-environment';
import paypal from 'config/paypal';
import { ShopEnvironment } from 'config/types';

export default {
  ...commonEnvironment,
  apiEndpoint: 'https://api.petsdeli.ch',
  backInStockUrl: 'https://jzk1-schweiz.myshopify.com',
  contentfulEnv: 'master',
  foodaidEndpoint: 'https://api.petsdeli.de/fube-live-2023-04',
  ninetailedEnv: 'main',
  oosEndpoint: 'https://api.oos.petsdeli.ch',
  paypalClientId: paypal.production,
  pdexEndpoint: 'https://merchant.petsdeli.ch',
  shopifyUrl: 'https://shop.petsdeli.ch',
  gtmScriptUrl: 'https://sst.petsdeli.ch/g27fwnhmpv.js?tg=NK69QT6',
  gtmNoScriptUrl: 'https://sst.petsdeli.ch/g27fwnhmpv.html?tg=NK69QT6',
} satisfies ShopEnvironment;
